/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Pdf_Page3_Info_LexiqueInputs */



/**
* | output |
* | --- |
* | "See the EISOX maintenance guide for procedures." |
*
* @param {Intervention_Plan_Pdf_Page3_Info_LexiqueInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_pdf_page3_info_lexique = /** @type {((inputs?: Intervention_Plan_Pdf_Page3_Info_LexiqueInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Pdf_Page3_Info_LexiqueInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("See the EISOX maintenance guide for procedures.")
	return /** @type {LocalizedString} */ ("Informations sur les procedures à suivre dans le guide de maintenance EISOX.")
});